import React from 'react';
import styled, { css } from 'styled-components';
import theme from 'styles/theme';
import 'assets/fonts/styles-font.css';
import FlexPayLogo from 'assets/images/flexpay-logo.svg';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';

const BannerContainer = styled.div`
  display: flex !important;

  background-color: ${theme.colors.upgradeGreen};

  flex-flow: column nowrap;
  white-space: nowrap;

  border-radius: 6px;
  width: 1174px;
  flex-shrink: 0;

  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  align-self: center;

  padding: 16px 48px;
  margin-top: 1rem !important;
  margin: 0 auto;
`;

const BannerHeader = styled.div`
  color: ${theme.colors.upliftWhite};
  flex-direction: column;
  font-size: 31.47px;
  display: flex !important;
  gap: 8px;
`;

export const buttonStyle = css`
  background-color: ${theme.colors.upliftWhite};

  border: none;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  color: ${theme.colors.upliftBlack};
  box-shadow: none !important;

  &.btn-primary:not(:disabled):not(.disabled).active,
  &.btn-primary:not(:disabled):not(.disabled):active,
  &.show > .btn-primary.dropdown-toggle {
    color: ${theme.colors.upliftGrey};
    background-color: ${theme.colors.upliftWhite};
    border-color: ${theme.colors.upgradeActiveButton};
  }

  &.btn-primary:hover,
  &:hover {
    color: ${theme.colors.upliftBlack};
    background-color: ${theme.colors.upliftWhite};
    border: 1px solid ${theme.colors.upgradeActiveButton};
    &:not(:disabled):not(.disabled):active {
      border: 1px solid ${theme.colors.upgradeActiveButton};
    }
  }

  &:disabled {
    background-color: ${theme.colors.upliftWhite};
    border-color: ${theme.colors.backgroundGrey};
    color: ${theme.colors.headerGrey};
    cursor: not-allowed !important;
  }
`;

export const StyledButton = styled(Button)`
  ${buttonStyle}
`;

const Header = styled.span`
  font-family: ${theme.font.fontFamily.flexpay};

  font-weight: 500;
  white-space: pre-line;
`;

const SubHeader = styled.span`
  font-family: ${theme.font.fontFamily.flexpay};
  font-weight: 400;
  font-size: 16px;
  white-space: pre-line;
`;

const StyledFlexpayLogo = styled.img`
  margin-left: 8px;
  margin-bottom: 8px;
  vertical-align: middle;
`;

const FlexPayBanner = () => {
  const { t } = useTranslation();
  return (
    <BannerContainer>
      <BannerHeader>
        <Header>
          <div>
            {t('banner.uplift_is_becoming')}
            <StyledFlexpayLogo src={FlexPayLogo} />
          </div>
        </Header>
        <SubHeader>{t('banner.new_look_same_product')}</SubHeader>
      </BannerHeader>
      <a
        href="https://www.upgrade.com/flex-pay/frequently-asked-questions/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <StyledButton>{t('banner.see_faq')}</StyledButton>
      </a>
    </BannerContainer>
  );
};

export default FlexPayBanner;
